import dynamic from "next/dynamic";
const CarouselTestimonialsComponent = dynamic(()=>import("./carousel-testimonials-component"));
import CarouselTestimonialsConfig from "./carousel-testimonials-config";
import CarouselTestimonialsAdvancedConfig from "./carousel-testimonials-advanced-config";
export default {
    CarouselTestimonialsComponent,
    CarouselTestimonialsConfig,
    CarouselTestimonialsAdvancedConfig
};
